<template>
  <div class="skill-manage-container">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="searchForm.name" placeholder="请输入分类名称" clearable />
        </el-col>

        <el-col :span="6">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width:100%">
            <el-option label="启用" value="1" />
            <el-option label="停用" value="0" />
          </el-select>
        </el-col>

        <el-col :span="6">
          <el-button type="primary" @click="queryList">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button @click="resetSearch" style="margin-left:10px">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 列表 -->
    <el-card class="list-card">
      <div slot="header" class="flex justify-between">
        <span>维修分类管理</span>
        <el-button type="primary" size="small" @click="handleAdd(null, 1)">
          <i class="el-icon-plus"></i>
          新增专业条线
        </el-button>
      </div>

      <el-table 
        :data="tableData" 
        border 
        v-loading="loading"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="name" label="分类名称" align="left" min-width="200">
          <template slot-scope="scope">
            <span :style="{ fontWeight: scope.row.categoryType == 1 ? 'bold' : 'normal' }">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="categoryType" label="类型" align="center" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.categoryType == 1 ? 'primary' : 'success'" size="small">
              {{ scope.row.categoryType == 1 ? '一级分类' : '二级分类' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" align="center" width="100" />
        <el-table-column prop="status" label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status == 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180" />
        <el-table-column label="操作" align="center" width="280">
          <template slot-scope="scope">
            <el-button v-if="scope.row.categoryType == 1" size="mini" type="success" @click="handleAdd(scope.row, 2)">
              添加子类
            </el-button>
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <el-form-item v-if="form.categoryType == 2" label="所属专业条线" prop="parentId">
          <el-select v-model="form.parentId" placeholder="请选择所属专业条线" style="width:100%" :disabled="!!form.id">
            <el-option 
              v-for="item in firstLevelList" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" :placeholder="form.categoryType == 1 ? '如：强电、弱电、给排水' : '如：照明灯具、开关插座'" />
        </el-form-item>
        <el-form-item label="排序权重" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" :max="9999" style="width:100%" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listRepairCategories,
  saveOrUpdateRepairCategory,
  deleteRepairCategory
} from '@/api/work/skillApi'

export default {
  name: 'SkillManageList',
  data() {
    return {
      searchForm: {
        name: '',
        status: ''
      },
      tableData: [],
      firstLevelList: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      form: {
        id: null,
        parentId: null,
        name: '',
        categoryType: 1,
        sortOrder: 100,
        status: 1
      },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        categoryType: [{ required: true, message: '请选择分类类型', trigger: 'change' }],
        parentId: [{ required: true, message: '请选择所属专业条线', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async loadList() {
      this.loading = true
      try {
        const params = { ...this.searchForm }
        Object.keys(params).forEach(key => {
          if (params[key] === '') delete params[key]
        })

        const { data } = await listRepairCategories(params)
        
        console.log('原始数据:', data)
        
        // 后端已经返回了树形结构，childrenCategories 就是子分类
        // 需要将 childrenCategories 重命名为 children 以适配 el-table
        this.firstLevelList = data.filter(item => item.categoryType == 1 || item.categoryType === '1')
        
        this.tableData = data.map(item => {
          return {
            ...item,
            children: item.childrenCategories || []
          }
        })
        
        console.log('最终表格数据:', this.tableData)
      } catch (error) {
        console.log('获取列表失败:', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    queryList() {
      this.loadList()
    },
    resetSearch() {
      this.searchForm = {
        name: '',
        status: ''
      }
      this.queryList()
    },
    handleAdd(row, categoryType) {
      if (categoryType == 1) {
        this.dialogTitle = '新增专业条线'
        this.form = {
          id: null,
          parentId: null,
          name: '',
          categoryType: 1,
          sortOrder: (this.firstLevelList.length + 1) * 100,
          status: 1
        }
      } else {
        this.dialogTitle = '添加维修部位'
        const children = row.children || []
        this.form = {
          id: null,
          parentId: row.id,
          name: '',
          categoryType: 2,
          sortOrder: (children.length + 1) * 100,
          status: 1
        }
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = row.categoryType == 1 ? '编辑专业条线' : '编辑维修部位'
      this.form = {
        id: row.id,
        parentId: row.parentId || null,
        name: row.name,
        categoryType: row.categoryType,
        sortOrder: row.sortOrder,
        status: row.status
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        // 二级分类必须有父级ID
        if (this.form.categoryType == 2 && !this.form.parentId) {
          this.$message.error('请选择所属专业条线')
          return
        }
        
        this.submitLoading = true
        try {
          const submitData = { ...this.form }
          // 一级分类不需要parentId
          if (submitData.categoryType == 1) {
            delete submitData.parentId
          }
          
          await saveOrUpdateRepairCategory(submitData)
          this.$message.success(this.form.id ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.loadList()
        } catch (error) {
          console.log('保存失败:', error)
          this.$message.error(error.message || '保存失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    async handleDelete({ id, categoryType, children }) {
      // 如果是一级分类且有子分类，不允许删除
      if (categoryType == 1 && children && children.length > 0) {
        this.$message.warning('该专业条线下还有维修部位，请先删除子分类')
        return
      }
      
      try {
        await this.$confirm('确定要删除该分类吗？', '提示', {
          type: 'warning'
        })
        await deleteRepairCategory(id)
        this.$message.success('删除成功')
        this.loadList()
      } catch (error) {
        if (error !== 'cancel') {
          console.log('删除失败:', error)
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.skill-manage-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .list-card {
    margin-bottom: 20px;
  }
}

// 表单项内容左对齐
::v-deep .el-form-item__content {
  text-align: left;
}
</style>
